


// import { Chip } from "@mui/material";
// import StatusCell from "./StatusCell";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import PendingOrdersCell from "./PendingOrdersCell";
// import ActionsCell from "./ActionsCell";

// export const getColumns = (setSelectedRow, setOpenStatusChangeModal,onUpdateSuccess) => [
//   {
//     field: "sn",
//     headerName: "SN",
//     width: 60,
//     sortable: false,
//     filterable: false,
//     renderCell: (params) => {
//       const visibleSortedRows = params.api.getSortedRowIds?.();
//       const index = visibleSortedRows?.indexOf(params.id);
//       return index !== undefined ? index + 1 : "";
//     },
//   },
//   {
//     field: "bay",
//     headerName: "Bay",
//     width: 100,
//   },
//   {
//     field: "is_priority_pickup",
//     headerName: "Priority Pickup",
//     width: 150,
//     headerAlign: "center",
//     align: "center",
//     renderCell: (params) => {
//       return params.value === 1 ? (
//         <Chip
//           icon={<CheckCircleIcon />}
//           label={"Yes"}
//           color={"success"}
//           variant="outlined"
//         />
//       ) : (
//         "-"
//       );
//     },
//   },
//   {
//     field: "is_order_sync_live",
//     headerName: "Order Live",
//     width: 210,
//     headerAlign: "center",
//     align: "center",
//     renderCell: (params) => (
//       <StatusCell
//         params={params}
//         setSelectedRow={setSelectedRow}
//         setOpenStatusChangeModal={setOpenStatusChangeModal}
//       />
//     ),
//   },
//   {
//     field: "pending_picking",
//     headerName: "Pending Picking",
//     width: 200,
//     headerAlign: "center",
//     align: "center",
//     renderCell: (params) => (
//       <PendingOrdersCell
//         data={params.value}
//         type="picking"
//         bay={params.row.bay}
//       />
//     ),
//   },
//   {
//     field: "pending_packing",
//     headerName: "Pending Packing",
//     width: 200,
//     headerAlign: "center",
//     align: "center",
//     renderCell: (params) => (
//       <PendingOrdersCell
//         data={params.value}
//         type="packing"
//         bay={params.row.bay}
//       />
//     ),
//   },
//   // {
//   //   field: "order_push_sequence_time",
//   //   headerName: "Order Push Sequence Time",
//   //   width: 220,
//   //   headerAlign: "center",
//   //   align: "center",
//   //   renderCell: (params) => {
//   //     // If null or undefined, show dash
//   //     if (params.value === null || params.value === undefined) {
//   //       return <span>-</span>;
//   //     }
      
//   //     // Otherwise just display the value as is
//   //     return <span>{params.value}</span>;
//   //   },
//   // },
//   {
//     field: "order_push_sequence_priority",
//     headerName: "Order Push Sequence ",
//     width: 250,
//     headerAlign: "center",
//     align: "center",
//     renderCell: (params) => {
//       // If null or undefined, show dash
//       if (params.value === null || params.value === undefined) {
//         return <span>-</span>;
//       }
      
//       // Otherwise just display the value as is
//       return <span>{params.value}</span>;
//     },
//   },
//   {
//     field: "auto_assigned",
//     headerName: "Auto Assigned",
//     width: 150,
//     headerAlign: "center",
//     align: "center",
//     renderCell: (params) => {
//       // This will be replaced with actual logic later
//       // For now, showing static "Yes" as an example
//       const isAutoAssigned = true; // Replace with actual condition later
      
//       return isAutoAssigned ? (
//         <Chip
//           icon={<CheckCircleIcon />}
//           label={"Yes"}
//           color={"success"}
//           variant="outlined"
//           sx={{
//             '& .MuiChip-icon': {
//               color: 'success.main'
//             }
//           }}
//         />
//       ) : (
//         <Chip
//           label={"No"}
//           color={"default"}
//           variant="outlined"
//           sx={{
//             backgroundColor: '#f5f5f5',
//             borderColor: '#e0e0e0',
//             color: '#666'
//           }}
//         />
//       );
//     },
//   },
//   {
//     field: "action",
//     headerName: "Action",
//     width: 300,
//     sortable: false,
//     renderCell: (params) => {
//       return (
//         <ActionsCell 
//           params={params} 
//           onUpdateSuccess={onUpdateSuccess} 
//         />
//       );;
//     },
//   },
// ];



// *******************************************************************************************************************


import { Chip } from "@mui/material";
import StatusCell from "./StatusCell";
import AutoAssignCell from "./AutoAssignCell"; // Import the new component
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PendingOrdersCell from "./PendingOrdersCell";
import ActionsCell from "./ActionsCell";

export const getColumns = (setSelectedRow, setOpenStatusChangeModal, onUpdateSuccess, onAutoAssignClick) => [
  {
    field: "sn",
    headerName: "SN",
    width: 60,
    sortable: false,
    filterable: false,
    renderCell: (params) => {
      const visibleSortedRows = params.api.getSortedRowIds?.();
      const index = visibleSortedRows?.indexOf(params.id);
      return index !== undefined ? index + 1 : "";
    },
  },
  {
    field: "bay",
    headerName: "Bay",
    width: 100,
  },
  {
    field: "is_priority_pickup",
    headerName: "Priority Pickup",
    width: 150,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return params.value === 1 ? (
        <Chip
          icon={<CheckCircleIcon />}
          label={"Yes"}
          color={"success"}
          variant="outlined"
        />
      ) : (
        "-"
      );
    },
  },
  {
    field: "is_order_sync_live",
    headerName: "Order Live",
    width: 210,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <StatusCell
        params={params}
        setSelectedRow={setSelectedRow}
        setOpenStatusChangeModal={setOpenStatusChangeModal}
      />
    ),
  },
  {
    field: "pending_picking",
    headerName: "Pending Picking",
    width: 200,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <PendingOrdersCell
        data={params.value}
        type="picking"
        bay={params.row.bay}
      />
    ),
  },
  {
    field: "pending_packing",
    headerName: "Pending Packing",
    width: 200,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <PendingOrdersCell
        data={params.value}
        type="packing"
        bay={params.row.bay}
      />
    ),
  },
  {
    field: "order_push_sequence_priority",
    headerName: "Order Push Sequence",
    width: 250,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      if (params.value === null || params.value === undefined) {
        return <span>-</span>;
      }
      return <span>{params.value}</span>;
    },
  },
  {
    field: "auto_assigned",
    headerName: "Auto Assigned",
    width: 150,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <AutoAssignCell
        params={params}
        onAutoAssignClick={onAutoAssignClick}
      />
    ),
  },
  // {
  //   field: "action",
  //   headerName: "Action",
  //   width: 300,
  //   sortable: false,
  //   renderCell: (params) => {
  //     return (
  //       <ActionsCell 
  //         params={params} 
  //         onUpdateSuccess={onUpdateSuccess} 
  //       />
  //     );
  //   },
  // },
];